export const site = {
    name: 'Osman Suliman',
    title: 'Osman Dev',
    role: 'Senior Mobile Engineer',
    location: 'Dubai, UAE',
    tagline: 'passionate about solving complex problems',
    email: 'mailosman.dev@gmail.com',
    phone: '+971 504648062',
}

const defaultLink = {
    x: -4.8,
    y: -3,
    halfExtents: {
        x: 3.2,
        y: 1.5,
    },
}

export const portfolioProjects = [
    {
        name: 'Mal Digital',
        client: 'MalBank',
        subtitle: 'AI-first Islamic digital bank',
        imageSources: ['./images/project-logos/mal.png'],
        description:
            'AI-first digital bank built on Islamic values — borderless, branchless banking with send, card, finance, and cross-border payment flows.',
        techStack: ['Swift', 'AI', 'Islamic Finance', 'Fintech'],
        link: {
            href: 'https://apps.apple.com/ae/app/mal-digital/id6775489610',
            ...defaultLink,
        },
        distinctions: [],
    },
    {
        name: 'ENBD X',
        client: 'Emirates NBD',
        subtitle: '+9M active customers',
        imageSources: ['./images/project-logos/enbd.png'],
        description:
            'Leading mobile banking app with 9M+ active customers across the MENA region.',
        techStack: ['Swift', 'SwiftUI', 'Mobile Banking'],
        link: {
            href: 'https://www.emiratesnbd.com/en/ways-of-banking/mobile-banking',
            x: -4.8,
            y: -3.3,
            halfExtents: defaultLink.halfExtents,
        },
        distinctions: [],
    },
    {
        name: 'EI+',
        client: 'Emirates Islamic',
        subtitle: 'Bank anytime, anywhere',
        imageSources: ['./images/project-logos/ei.png'],
        description:
            'Digital banking platform enabling customers to bank anytime, anywhere.',
        techStack: ['Swift', 'Mobile Banking'],
        link: {
            href: 'https://www.emiratesislamic.ae/en/ei-plus-interstitial-page',
            x: -4.8,
            y: -2,
            halfExtents: defaultLink.halfExtents,
        },
        distinctions: [],
    },
    {
        name: 'Real Research',
        client: 'Real Research',
        subtitle: '2M+ active survey users',
        imageSources: ['./images/project-logos/real-research.png'],
        description:
            'Survey platform with 2M+ active users focused on research innovation.',
        techStack: ['Flutter', 'Surveys'],
        link: {
            href: '#',
            ...defaultLink,
        },
        distinctions: [],
    },
    {
        name: 'Artaah',
        client: 'Artaah',
        subtitle: 'Luggage services marketplace',
        imageSources: ['./images/project-logos/artaah.png'],
        description:
            'Luggage services marketplace with safe transactions and booking flows.',
        techStack: ['Flutter', 'Marketplace'],
        link: {
            href: 'https://apps.apple.com/ae/app/artaah-customer/id6737255077',
            x: -4.8,
            y: -4,
            halfExtents: defaultLink.halfExtents,
        },
        distinctions: [],
    },
    {
        name: 'Newsreels',
        client: 'Newsreels',
        subtitle: 'TikTok for news',
        imageSources: ['./images/project-logos/newsreels.png'],
        description:
            'Short-form news experience with TikTok-style discovery for news content.',
        techStack: ['Swift', 'Media'],
        link: {
            href: 'https://www.newsreels.app/',
            x: -4.8,
            y: -2,
            halfExtents: defaultLink.halfExtents,
        },
        distinctions: [],
    },
    {
        name: 'Liv X',
        client: 'Liv Bank',
        subtitle: 'Next-gen digital banking',
        imageSources: ['./images/project-logos/liv.png'],
        description:
            'Next-generation digital banking app for a modern customer base.',
        techStack: ['Swift', 'Digital Banking'],
        link: {
            href: 'https://www.liv.me/en/ways-of-banking/liv-x-app',
            ...defaultLink,
        },
        distinctions: [],
    },
    {
        name: 'Rateena',
        client: 'Rateena',
        subtitle: 'New-gen e-commerce',
        imageSources: ['./images/project-logos/rateena.png'],
        description:
            'New-generation e-commerce mobile experience for regional users.',
        techStack: ['Flutter', 'E-Commerce'],
        link: {
            href: 'https://apps.apple.com/ae/app/rateena-%D8%B1%D8%AA%D9%8A%D9%86%D8%A9/id6618146055',
            x: -4.8,
            y: -3.4,
            halfExtents: defaultLink.halfExtents,
        },
        distinctions: [],
    },
    {
        name: 'Comet',
        client: 'Ahoy Comet',
        subtitle: 'Logistics operations platform',
        imageSources: ['./images/project-logos/comet.png'],
        description:
            'Logistics operations platform orchestrating complex supply chain workflows.',
        techStack: ['Swift', 'Logistics', 'ARKit'],
        link: {
            href: 'https://www.ahoycomet.com/',
            x: -4.8,
            y: -4.4,
            halfExtents: defaultLink.halfExtents,
        },
        distinctions: [],
    },
]

export const portfolioExperiences = [
    {
        company: 'Mal',
        logo: './images/company-logos/mal.png',
        title: 'AI Mobile Team Lead',
        period: 'Apr 2026 – Present · Hybrid',
        description:
            'Leading the AI mobile engineering team on product strategy and delivery across hybrid teams.',
        highlights: [
            'Driving AI-assisted mobile development workflows.',
            'Cross-functional delivery with product and design.',
        ],
    },
    {
        company: 'Emirates NBD',
        logo: './images/company-logos/emirates-nbd.png',
        title: 'Senior Mobile Engineer',
        period: 'Oct 2023 – Apr 2026 · Dubai',
        description:
            'Built secure banking features for 9M+ customers including transfers, bill split, and fraud detection.',
        highlights: [
            'Recognized by the Group Chief Digital & Information Officer.',
            'Led Agile ceremonies across architecture and business teams.',
        ],
    },
    {
        company: 'AHOY LLC',
        logo: './images/company-logos/ahoy.png',
        title: 'Senior Mobile Engineer',
        period: 'Sep 2021 – Oct 2023 · Dubai',
        description:
            'Designed modular logistics architecture and AR/IoT solutions across MENA partner apps.',
        highlights: [
            'Built SDKs as secure CocoaPods for partner integration.',
            'Hiring and onboarding for mobile engineering.',
        ],
    },
    {
        company: 'TNC Group',
        logo: './images/company-logos/tnc.png',
        title: 'Mobile Engineer',
        period: 'Aug 2019 – Sep 2021 · Dubai',
        description:
            'Scaled a blockchain platform to 3M+ users with innovative payment experiences.',
        highlights: [
            'Solved complex crypto payment challenges.',
            'Drove agile adoption across global teams.',
        ],
    },
    {
        company: 'XZone',
        logo: './images/company-logos/xzone.png',
        title: 'Mobile Engineer',
        period: 'Sep 2016 – Jun 2019 · Dubai',
        description:
            'Built delivery apps with real-time tracking and regional e-payment integrations.',
        highlights: [
            'Integrated STC, Hyperpay, and Syberpay gateways.',
            'Designed scalable SaaS mobile architecture.',
        ],
    },
    {
        company: 'Goldsmiths, University of London',
        logo: './images/company-logos/goldsmiths.png',
        title: 'Artificial Intelligence',
        period: 'Postgraduate',
        description: 'Postgraduate studies focused on AI and machine learning foundations.',
        highlights: ['Machine learning and intelligent systems.'],
    },
    {
        company: 'Sudan University of Science and Technology',
        logo: './images/company-logos/sust.png',
        title: 'Bachelor of Science',
        period: 'Undergraduate',
        description: 'Engineering and computer science foundation.',
        highlights: ['Computer science and engineering fundamentals.'],
    },
]

export const contactLinks = [
    {
        href: 'https://github.com/OzmanDev',
        textureKey: 'informationContactGithubLabel',
        slot: 1,
    },
    {
        href: 'https://www.linkedin.com/in/osman-dev',
        textureKey: 'informationContactLinkedinLabel',
        slot: 2,
    },
    {
        href: 'mailto:mailosman.dev@gmail.com',
        textureKey: 'informationContactMailLabel',
        slot: 3,
    },
]
